












import {Vue, Component, Prop} from 'vue-property-decorator';
import SkillDiagram from './SkillDiagram.vue';

@Component({
    name: 'SkillDiagramWrapper',
    components: {SkillDiagram},
})
export default class SkillDiagramWrapper extends Vue {
    @Prop({required: true}) public id!: number | string;
    @Prop({required: true}) public title!: string;
    @Prop({default: () => [40, 60]}) public ratio!: number[];

    public get percentage(): number {
        return this.ratio[0];
    }
}
